import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import { reduxForm } from 'redux-form';
import partial from 'lodash/partial';
import idx from 'idx';
import { getProjectIdFromUrl } from 'project/utils';
import { updateUser } from 'common/ducks/user';
import {
  toggleAddModal, changeAddStep, fetchAll, createRequest, addParticipantRequest, addRevisionRequest
} from 'presentations/ducks';
import { ADD_FORM_NAME } from 'presentations/constants';
import { DEFAULT_REQUIRED_MESSAGE, REQUIRED_COLOR_MESSAGE } from 'common/components/form_fields';
import { validateSubDomain } from 'presentations/utils';
import AddModal from 'presentations/components/add_modal';

const mapStateToProps = (state) => {
  const { addStep, showingAddModal } = state.project.presentations;
  const { profile_data } = state.user;
  const initialValues = {
    use_standard_colors: true,
    share_results: true,
    permissions: 'voting_and_comments',
    selected_revisions: [],
    weight_votes: false,
    participants: [],
    first_name: idx(profile_data, _ => _.first_name),
    last_name: idx(profile_data, _ => _.last_name),
  };

  return {
    userId: idx(profile_data, _ => _.id),
    step: addStep,
    showing: showingAddModal,
    initialValues
  };
}

const mapDispatchToProps = (dispatch, { params }) => {
  const projectId = getProjectIdFromUrl(params);

  return bindActionCreators({
    toggle: toggleAddModal,
    changeStep: changeAddStep,
    fetchAll: partial(fetchAll, projectId),
    createRequest: partial(createRequest, projectId),
    addParticipantRequest,
    addRevisionRequest,
    updateUser
  }, dispatch);
}

const validate = (values) => {
  const errors = {};
  const requiredFields = ['name', 'password', 'sub_domain', 'purpose', 'first_name', 'last_name'];
  for (let f of requiredFields) {
    if (!values[f]) errors[f] = DEFAULT_REQUIRED_MESSAGE;
  }
  if (!errors.sub_domain) {
    errors.sub_domain = validateSubDomain(values.sub_domain);
  }
  if (!values.selected_revisions || values.selected_revisions.length < 1) {
    errors.selected_revisions = 'You must select at least 1 revision';
  }
  if (!values.use_standard_colors && !values.custom_primary_color) {
    errors.custom_primary_color = REQUIRED_COLOR_MESSAGE;
  }
  return errors;
}

const Form = reduxForm({
  form: ADD_FORM_NAME,
  validate
})(AddModal);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Form));



// WEBPACK FOOTER //
// ./presentations/containers/add_modal.js